/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type { SyncQueryResponse, Sync401 } from "../types/Sync.ts"
import { syncQueryResponseSchema } from "../zod/syncSchema.ts"

function getSyncUrl() {
  const res = { method: "GET", url: `/sync` as const }
  return res
}

/**
 * @summary Sync user data
 * {@link /sync}
 */
export async function sync(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SyncQueryResponse,
    ResponseErrorConfig<Sync401>,
    unknown
  >({ method: "GET", url: getSyncUrl().url.toString(), ...requestConfig })
  return syncQueryResponseSchema.parse(res.data)
}
